import { Pipe, PipeTransform } from '@angular/core';
@Pipe({name: 'educationAndTrainingFor'})
export class EducationAndTrainingForPipe implements PipeTransform {
  transform(value: number, exponent?: number): string {
    return value == 1 ? 'Đơn vị quản lý cấp Tỉnh/thành phố' :  value == 4 ? 'Trung Tâm GDĐB ' :  value == 3 ? 'Cơ sở' : 'Đơn vị quản lý cấp Quận/huyện';
  }
}